import React from 'react'
import { FormGroup, ControlLabel, Col } from 'react-bootstrap'

const FormInput = ({
  type,
  name,
  label,
  placeholder,
  input,
  className
}: {
  type: string,
  name: string,
  label: string,
  placeholder: string,
  input: {
    value: string
  },
  className: string
}) => (
  <FormGroup controlId={name}>
    <Col componentClass={ControlLabel} sm={4}>
      {label}
    </Col>
    <Col sm={4}>
      <input type={type} className={className} placeholder={placeholder} {...input}/>
    </Col>
  </FormGroup>
)

export default FormInput



// WEBPACK FOOTER //
// ./src/components/FormInput.js